<template>
  <div>
    <div class="pay-image-header">
      <img src="../assets/china-bank.png" alt='loading'></img>
    </div>
    <div class="payment">
      <div class="pay-header">
        <span class="title-new">Bank of China</span>
        <div class="step-new">
          <el-steps :active="active">
            <el-step icon="el-icon-picture"></el-step>
            <el-step icon="el-icon-picture"></el-step>
            <el-step icon="el-icon-picture"></el-step>
          </el-steps>
        </div>
      </div>
      <div class="pay-middle">
        <div class="status-info">
          Status:
          <a href="#" style="color:green">{{paymentModel.status}}</a>
          </br>
          Reference number:{{paymentModel.debitAuthNo}}
          </br>
          Transaction date:{{paymentModel.tranDate}}
          </br>
          Transaction time:{{paymentModel.tranTime.replace("-",":").replace("-",":")}}
        </div>

        <div class="pay-row-success row-status1">
          <span class="row-status-name1">Amount:</span>
          <span>{{paymentModel.accountCurrency}}&nbsp;{{paymentModel.tranAmount}}</span>
        </div>

        <div class="pay-row-success">
          <span class="row-status-name2">Fee Amount:</span>
          <span>{{paymentModel.accountCurrency}}&nbsp;{{paymentModel.feeAmount}}</span>
        </div>

        <div class="pay-row-success">
          <span class="row-status-name3">From Account:</span>
          <span>{{paymentModel.accounNo}}</span>
        </div>

        <div class="pay-row-success">
          <span class="row-status-name4">Buyer Name:</span>
          <span>{{paymentModel.buyerName}}</span>
        </div>

        <div class="pay-row-success">
          <span class="row-status-name5">Merchant Name:</span>
          <span>{{paymentModel.sellerDesc}}</span>
        </div>

        <div class="pay-row-success">
          <span class="row-status-name6">Payment Reference:</span>
          <span>{{paymentModel.sellerOrderNo}}</span>
        </div>

        <div class="pay-row-success">
          <span class="row-status-name7">FPX Transaction ID:</span>
          <span>{{paymentModel.fpxTranId}}</span>
        </div>

        <div class="note-success">
          <p>
            <span>Important Note:</span>
            <br/> 1.&nbsp;
            <span class="striking">This is NOT the final confirmation</span>
            of your payment. Please check with your
            <br/>
            <span class="note-one-space">merchant for final status confirmation.</span>
          </p>
          <p>
            2.&nbsp; Please click on the "Continue with Transaction" button below and
            <span class="striking">DO NOT</span> close
            <br/>
            <span class="note-one-space">the browser until final receipt is displayed.</span>
          </p>
        </div>

        <div class="pay-button">
          <el-button @click="next()" type="danger">Continue with Transaction ({{toTime}}s)</el-button>
        </div>
      </div>
      <div class="payfoot"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PaymentSuccess",
    data() {
      return {
        toTime: 10,
        active: 3,
        paymentModel: {
          makerName: '',
          fpxTranId: '',
          tranAmount: '',
          feeAmount: '',
          accounNo: '',
          buyerName: '',
          accountCurrency: '',
          status: '',
          opxpPaymentNo: '',
          tranDate: '',
          tranTime: '',
          sellerOrderNo: ''
        },
        timerStatus: false,
      };
    },

    created() {
      this.getSuccessfulResult();
      let taskid = setInterval(() => {
        if (this.toTime > 1) {
          this.toTime--;
        } else {
          clearInterval(taskid);
          this.next();
        }
      }, 1000);
    },

    methods: {
      next() {
        window.sessionStorage.setItem('message', "Payment Successful and you have log out.")
        this.$router.replace({ name: 'ReturnToFpx' })
      },

      getSuccessfulResult() {
        let successfulResult = JSON.parse(window.sessionStorage.getItem('Successful'));
        window.sessionStorage.setItem('indirectURL', successfulResult.respUrl);
        for (let key in successfulResult) {
          this.paymentModel[key] = successfulResult[key]
        }
      },
    },

  }
</script>

<style scoped>
  .striking {
    color: #1FC2FE
  }
</style>

<style lang='less' scoped>
  @media screen and (max-width: 640px) {
    @import "../styles/mobile/m_payment.less";
  }

  @media screen and (min-width: 641px) {
    @import "../styles/pc/payment.less";
  }
</style>


// WEBPACK FOOTER //
// src/views/PaymentThree.vue